<template>
  <div class="container row mb-3" style="margin: auto">
    <div class="row mt-3" v-if="status">
       <div style="width: 5%"></div>
      <div class="col-md-8">
        <h4>การสอบครั้งที่ {{test_no}} </h4>
      </div>
      <div style="width: 5%"></div>
      <div class="col-md-8" style="width: 55%">
        <div class="card col-md-12" style="height: 100%">
          <div class="mt-3 mb-3">
            <div style="padding: 10px">
              <label class="mb-3 mt-3"
                >{{ question.index }}.  <span v-html="question.question"></span></label
              ><br />
              <div v-if="question.type == 3">
                <div
                  class="form-check mb-3"
                  v-for="(a, i) in question.key"
                  :key="i"
                >
                  <input
                    v-model="a.answer"
                    class="form-control"
                    style="width: 30%"
                    type="text"
                    id="flexRadioDefault1"
                  />
                </div>
              </div>
              <div
                v-else
                class="form-check mb-3"
                v-for="(a, i) in question.key"
                :key="i"
              >
                <input
                  v-model="question.answer1"
                  class="form-check-input"
                  type="radio"
                  :name="question.index"
                  :id="a.answer"
                  :key="a.answer"
                  :value="a.answer"
                />
                <label class="form-check-label" :for="a.answer">
                  <span v-html="a.answer"></span>
                </label>
              </div>
            </div>
          </div>
          <div class="text-right mb-3">
            <button
              type="button"
              class="btn btn-info"
              @click="back()"
              style="float: left; margin: 5px"
              v-if="question.index != 1"
            >
              <i class="fa fa-arrow-left"></i>
            </button>
            <button
              type="button"
              class="btn btn-info"
              @click="next()"
              style="float: right; margin: 5px"
              v-if="question.index != questions.length"
            >
              <i class="fa fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
      <div
        class="col-md-4"
        style="width: 35%; overflow-y: scroll; height: 600px"
      >
        <div style="padding: 15px; height: 100%">
          <div class="row">
            <div
              class="col-md-12 mb-3"
              v-for="(q, i) in questions"
              :key="i"
              @click="getquestion(q, i + 1)"
            >
              <div class="myDIV" style="margin: auto; cursor: pointer">
                <div
                  style="
                    background-color: #93fba6;
                    border-style: solid;
                    border-width: thin;
                    padding: 5px;
                  "
                  v-if="q.type == 3 && q.answer1"
                >
                  ข้อที่ {{ i + 1 }}.  <span v-html="q.question"></span><br />
                  <div
                    class="form-check col-md-5"
                    v-for="(a, i) in q.key"
                    :key="i"
                  >
                    <input
                      disabled
                      v-model="a.answer"
                      class="form-control form-control-sm"
                      style="width: 100%"
                      type="text"
                      id="flexRadioDefault1"
                    />
                  </div>
                </div>
                <div
                  v-if="q.type == 3 && !q.answer1"
                  style="border-style: solid; border-width: thin; padding: 5px"
                >
                  ข้อที่ {{ i + 1 }}. <span v-html="q.question"></span><br />
                  <div
                    class="form-check col-md-5"
                    v-for="(a, i) in q.key"
                    :key="i"
                  >
                    <input
                      disabled
                      :v-model="a.answer"
                      class="form-control form-control-sm"
                      style="width: 100%"
                      type="text"
                      id="flexRadioDefault1"
                    />
                  </div>
                </div>
                <div
                  style="
                    background-color: #93fba6;
                    border-style: solid;
                    border-width: thin;
                    padding: 5px;
                  "
                  v-if="q.type != 3 && q.answer1"
                >
                  ข้อที่ {{ i + 1 }}. <span v-html="q.question"></span><br />                  
                  <div class="form-check" v-for="(a, i) in q.key" :key="i">
                    <input
                      disabled
                      v-model="q.answer1"
                      class="form-check-input"
                      type="radio"
                      :name="q.question"
                      :id="a.answer"
                      :key="a.answer"
                      :value="a.answer"
                    />
                    
                    <label class="form-check-label">
                      <span v-html="a.answer"></span>
                    </label>
                  </div>
                </div>
                <div
                  style="border-style: solid; border-width: thin; padding: 5px"
                  v-if="q.type != 3 && !q.answer1"
                >
                  ข้อที่ {{ i + 1 }}. <span v-html="q.question"></span><br />
                  
                  <div class="form-check" v-for="(a, i) in q.key" :key="i">
                    <input
                      disabled
                      v-model="q.answer1"
                      class="form-check-input"
                      type="radio"
                      :name="q.question"
                      :id="a.answer"
                      :key="a.answer"
                      :value="a.answer"
                    />
                    <label class="form-check-label">
                      <span v-html="a.answer"></span>
                    </label>
                  </div>
                </div>
              </div>
              <!-- <div class="hide">
              <label class="mb-3 mt-3">{{ i + 1 }}. {{ q.question }}</label
              ><br />
              <img
                class="mb-3"
                v-if="checkq(q.image)"
                :src="
                  'https://api-test.ponnipa.in.th/uploads/' + question.image
                "
                style="width: 20%"
              />
              <div v-if="q.questiontype == 2">
                <div class="form-check mb-3" v-for="(a, i) in q.key" :key="i">
                  <input
                    v-model="a.answer"
                    class="form-control"
                    style="width: 100%"
                    type="text"
                    id="flexRadioDefault1"
                  />
                </div>
              </div>
              <div
                v-else
                class="form-check mb-3"
                v-for="(a, i) in q.key"
                :key="i"
              >
                <input
                  v-model="q.answer"
                  class="form-check-input"
                  type="radio"
                  :name="i + 1"
                  :id="a.answer"
                  :value="a.answer"
                  :checked="a.check"
                  @click="addanswer(a.answer)"
                />
                <label class="form-check-label" :for="a.answer">
                  {{ a.answer }}
                </label>
              </div>
            </div> -->
            </div>
          </div>
        </div>
      </div>
      <div style="width: 5%"></div>
      <div class="text-center mt-3">
        <span style="color: red">*</span> ทำข้อสอบครบทุกข้อ
        คลิกปุ่มยืนยันการส่งข้อสอบ
        <br />
        <button
          type="button"
          class="btn btn-success btn-sm"
          @click="save()"
          style="float: center; margin: 5px"
        >
          ยืนยันการส่งข้อสอบ
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import RandomService from "../services/RandomService";
import QuestionSubject from "../services/QuestionSubject";
import QuestionObject from "../services/QuestionObject";

import ManageTraining from "../services/ManageTraining";
import AnswerTrainingService from "../services/AnswerTrainingService";
import AnswerTempTrainingService from "../services/AnswerTempTrainingService";

export default {
  name: "Nav",
  props: {
    msg: String,
  },
  components: {  },
  data() {
    return {
      questions: [],
      question: {},
      status: true,
      test_no:1
    };
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/");
    } else {
      this.getrandom();
    }
  },
  methods: {
    save() {      
    // console.log(this.questions);
      var check = false;
      for (let q = 0; q < this.questions.length; q++) {
        if (this.questions[q].answer1 == "") {
          alert("กรุณาตอบคำถามให้ครบทุกข้อ");
          check = true;
          break;
        }
      }
      if (check == false) {
        for (let q = 0; q < this.questions.length; q++) {
          var answer = [];
          if (
            this.questions[q].type == 1 ||
            this.questions[q].type == 3
          ) {
            QuestionSubject.getQuestionSubject(
              this.questions[q].question_id,
              this.questions[q].question_set_id
            ).then((res) => {
              // console.log(res.data);
              var score = 0;
              answer = [];
              if (res.data.CorrectAns1 != "-") {
                answer.push(res.data.CorrectAns1);
              }
              if (res.data.CorrectAns2 != "-") {
                answer.push(res.data.CorrectAns2);
              }
              if (res.data.CorrectAns3 != "-") {
                answer.push(res.data.CorrectAns3);
              }
              if (res.data.CorrectAns4 != "-") {
                answer.push(res.data.CorrectAns4);
              }
              if (res.data.CorrectAns5 != "-") {
                answer.push(res.data.CorrectAns5);
              }
              if (res.data.CorrectAns6 != "-") {
                answer.push(res.data.CorrectAns6);
              }
              if (res.data.CorrectAns7 != "-") {
                answer.push(res.data.CorrectAns7);
              }
              if (res.data.CorrectAns8 != "-") {
                answer.push(res.data.CorrectAns8);
              }
              if (res.data.CorrectAns9 != "-") {
                answer.push(res.data.CorrectAns9);
              }
              if (res.data.CorrectAns10 != "-") {
                answer.push(res.data.CorrectAns10);
              }
              if (res.data.CorrectAns11 != "-") {
                answer.push(res.data.CorrectAns11);
              }
              if (res.data.CorrectAns12 != "-") {
                answer.push(res.data.CorrectAns12);
              }
              if (res.data.CorrectAns13 != "-") {
                answer.push(res.data.CorrectAns13);
              }
              if (res.data.CorrectAns14 != "-") {
                answer.push(res.data.CorrectAns14);
              }
              if (res.data.CorrectAns15 != "-") {
                answer.push(res.data.CorrectAns15);
              }
              var allscore = this.questions[q].no;
              allscore = 1 / allscore;
              // console.log(allscore);
              // console.log(answer);
              if (this.questions[q].type == 1) {
                let foundans = answer.find(
                  (element) => element == this.questions[q].answer1
                );
                // console.log(foundans);

                if (foundans) {
                  score = 1;
                }
                var data = {
                  index: this.questions[q].index,
                  image: this.questions[q].image,
                  question_id: this.questions[q].question_id,
                  question: this.questions[q].question,
                  question_set_id: this.questions[q].question_set_id,
                  no: this.questions[q].no,
                  student_id: this.currentUser.user_id,
                  ans1: this.questions[q].ans1,
                  ans2: this.questions[q].ans2,
                  ans3: this.questions[q].ans3,
                  ans4: this.questions[q].ans4,
                  ans5: this.questions[q].ans5,
                  answer1: this.questions[q].answer1,
                  answer2: this.questions[q].answer2,
                  answer3: this.questions[q].answer3,
                  score: score,
                  type: this.questions[q].type,
                  random_id: this.questions[q].random_id,
                test_no: this.questions[q].test_no,
                };
                // console.log(data);
                AnswerTrainingService.createAnswerStudent(data).then(() => {
                  // console.log(res.data);
                });
                if (score != 0) {
                  var count = { weight: score };
                  RandomService.updateRandomWeight(
                    this.questions[q].random_id,
                    count
                  ).then(() => {
                    // console.log(res.data);
                  });
                }
              } else {
                score = 0;
                var ansstu = [];
                for (let a = 0; a < this.questions[q].key.length; a++) {
                  ansstu.push(this.questions[q].key[a].answer);
                  // console.log(this.questions[q].key[a].answer);
                  let foundall = answer.find(
                    (element) => element == this.questions[q].key[a].answer
                  );
                  if (foundall) {
                    score = score + allscore;
                  }
                }
                data = {
                  index: this.questions[q].index,
                  image: this.questions[q].image,
                  question_id: this.questions[q].question_id,
                  question: this.questions[q].question,
                  question_set_id: this.questions[q].question_set_id,
                  no: this.questions[q].no,
                  student_id: this.currentUser.user_id,
                  ans1: this.questions[q].ans1,
                  ans2: this.questions[q].ans2,
                  ans3: this.questions[q].ans3,
                  ans4: this.questions[q].ans4,
                  ans5: this.questions[q].ans5,
                  answer1: this.questions[q].answer1,
                  answer2: this.questions[q].answer2,
                  answer3: this.questions[q].answer3,
                  score: score,
                  type: this.questions[q].type,
                  random_id: this.questions[q].random_id,
                test_no: this.questions[q].test_no,
                };
                // console.log(data);
                AnswerTrainingService.createAnswerStudent(data).then(() => {
                  // console.log(res.data);
                });
                if (score != 0) {
                  count = { weight: score };
                  RandomService.updateRandomWeight(
                    this.questions[q].random_id,
                    count
                  ).then(() => {
                    // console.log(res.data);
                  });
                }
                // console.log(data);
              }
            });
          } else if (this.questions[q].type == 2) {
            var score = 0;
            QuestionObject.getQuestionObject(
              this.questions[q].question_id,
              this.questions[q].question_set_id
            ).then((res) => {
              score = 0;
              // console.log(res.data.CorrectAns);
              console.log(this.questions[q].answer1);
              if (res.data.CorrectAns == this.questions[q].answer1) {
                score = 1;
              }
              var data = {
                index: this.questions[q].index,
                image: this.questions[q].image,
                question_id: this.questions[q].question_id,
                question: this.questions[q].question,
                question_set_id: this.questions[q].question_set_id,
                no: this.questions[q].no,
                student_id: this.currentUser.user_id,
                ans1: this.questions[q].ans1,
                ans2: this.questions[q].ans2,
                ans3: this.questions[q].ans3,
                ans4: this.questions[q].ans4,
                ans5: this.questions[q].ans5,
                answer1: this.questions[q].answer1,
                answer2: this.questions[q].answer2,
                answer3: this.questions[q].answer3,
                score: score,
                type: this.questions[q].type,
                random_id: this.questions[q].random_id,
                test_no: this.questions[q].test_no,
              };
              // console.log(data);

              AnswerTrainingService.createAnswerStudent(data).then(() => {
                // console.log(res.data);
              });
              if (score != 0) {
                var count = { weight: score };
                RandomService.updateRandomWeight(
                  this.questions[q].random_id,
                  count
                ).then(() => {
                  // console.log(res.data);
                });
              }
            });
          }
        }
        setTimeout(() => {
          AnswerTempTrainingService.DeleteAnswerTemps(
            this.currentUser.user_id
          ).then(() => {
            alert("บันทึกสำเร็จ");
            this.$router.push("/trainingresult");
          });
        }, 3000);
      }
    },
    saveanswer() {
      var data = {};
      if (this.question.type == 3) {
        var ans1 = "";
        var ans2 = "";
        var ans3 = "";
        for (let a = 0; a < this.question.key.length; a++) {
          if (a == 0) {
            ans1 = this.question.key[a].answer;
          }
          if (a == 1) {
            ans2 = this.question.key[a].answer;
          }
          if (a == 2) {
            ans3 = this.question.key[a].answer;
          }
        }
        data = {
          answer1: ans1,
          answer2: ans2,
          answer3: ans3,
        };
      } else {
        data = {
          answer1: this.question.answer1,
        };
      }
      AnswerTempTrainingService.updateAnswerTemp(this.question.id, data).then(
        () => {
          if (this.question.type == 3) {
            AnswerTempTrainingService.getAnswerTemps(
              this.currentUser.user_id,
              this.test_no
            ).then((res) => {
              // console.log(res.data);
              // console.log(res.data);
              this.questions = res.data;
              this.question = this.questions[this.question.index-1];
              // this.question.index = this.question.index - 1;
              // console.log(this.question.index);
            });
          }
        }
      );
    },
    back() {
      // console.log(this.question);
      var data = {};
      if (this.question.type == 3) {
        var ans1 = "";
        var ans2 = "";
        var ans3 = "";
        for (let a = 0; a < this.question.key.length; a++) {
          if (a == 0) {
            ans1 = this.question.key[a].answer;
          }
          if (a == 1) {
            ans2 = this.question.key[a].answer;
          }
          if (a == 2) {
            ans3 = this.question.key[a].answer;
          }
        }
        data = {
          answer1: ans1,
          answer2: ans2,
          answer3: ans3,
        };
      } else {
        data = {
          answer1: this.question.answer1,
        };
      }
      AnswerTempTrainingService.updateAnswerTemp(this.question.id, data).then(() => {
        // console.log(res.data);
        for (let q = 0; q < this.questions.length; q++) {
        // console.log(q);
        if (q == this.question.index - 2) {
          // console.log(q);
          this.question = {};
          // console.log(this.questions[q]);
          this.question = this.questions[q];
          this.question.index = q + 1;
          break;
        }
      }
      });
      
    },
    next() {
      // var ques = this.questions;
      // this.questions = [];
      // this.questions = ques;
      // console.log(this.question);
      var data = {};
      if (this.question.type == 3) {
        var ans1 = "";
        var ans2 = "";
        var ans3 = "";
        for (let a = 0; a < this.question.key.length; a++) {
          if (a == 0) {
            ans1 = this.question.key[a].answer;
          }
          if (a == 1) {
            ans2 = this.question.key[a].answer;
          }
          if (a == 2) {
            ans3 = this.question.key[a].answer;
          }
        }
        data = {
          answer1: ans1,
          answer2: ans2,
          answer3: ans3,
        };
      } else {
        data = {
          answer1: this.question.answer1,
        };
      }
      AnswerTempTrainingService.updateAnswerTemp(this.question.id, data).then(() => {
        // console.log(res.data);
        for (let q = 0; q < this.questions.length; q++) {
        if (q == this.question.index) {
          // console.log(q);
          this.question = {};
          // console.log(this.questions[q]);
          this.question = this.questions[q];
          this.question.index = q + 1;
          break;
        }
      }
      });
      // console.log(this.question.index);
      
    },
    checkq(data) {
      if (data) {
        return data.includes("Q");
      } else {
        return false;
      }
    },
    getquestion(q, i) {
      this.question = q;
      this.question.index = i;
      // console.log(this.question.key);
    },
    getquestions() {
      AnswerTempTrainingService.getAnswerTemps(this.currentUser.user_id, this.test_no).then(
        (res) => {
          // console.log(res.data);
           if (res.data.length != 0 && res.data.length == this.questions.length) {
        this.questions = [];
          this.questions = res.data;
          this.question = this.questions[0];            
          }else{
            this.questions = []
            this.getrandom();
          }
        }
      );
    },
    createquestion() {
      ManageTraining.getManageTraining().then((res) => {
        // console.log(res.data);
        if (res.data.length > 0) {
          RandomService.gettesttrain(
            res.data[0].from_no,
            res.data[0].to_no,
            this.test_no
          ).then((res) => {
            // console.log(res.data);
            this.questions = res.data;
            for (let q = 0; q < this.questions.length; q++) {
              var ans1 = "";
              var ans2 = "";
              var ans3 = "";
              var ans4 = "";
              var ans5 = "";
              for (let a = 0; a < this.questions[q].key.length; a++) {
                var index = a + 1;
                if (index == 1) {
                  ans1 = this.questions[q].key[a].answer;
                } else if (index == 2) {
                  ans2 = this.questions[q].key[a].answer;
                } else if (index == 3) {
                  ans3 = this.questions[q].key[a].answer;
                } else if (index == 4) {
                  ans4 = this.questions[q].key[a].answer;
                } else if (index == 5) {
                  ans5 = this.questions[q].key[a].answer;
                }
              }
              // console.log(ans1);
              // console.log(ans2);
              // console.log(ans3);
              // console.log(ans4);
              // console.log(ans5);
              if (this.questions[q].type != 3) {
                this.questions[q].no = 0;
              }

              var ans = {
                index: q + 1,
                image: this.questions[q].image,
                question_id: this.questions[q].id,
                question: this.questions[q].question,
                question_set_id: this.questions[q].questiontype,
                no: this.questions[q].no,
                student_id: this.currentUser.user_id,
                ans1: ans1,
                ans2: ans2,
                ans3: ans3,
                ans4: ans4,
                ans5: ans5,
                answer1: "",
                answer2: "",
                answer3: "",
                random_id: this.questions[q].random_id,
                type: this.questions[q].type,
                test_no:this.questions[q].test_no
              };
              // console.log(ans);
              AnswerTempTrainingService.createAnswerTemp(ans).then(() => {
                if (this.questions.length == q+1) {              
        this.getquestions();
            }
              });
            }
            // this.getquestions();
          });
        }
      });
    },
    getrandom() {
      AnswerTrainingService.getAnswerStudents(this.currentUser.user_id).then(
        (res) => {
          if (res.data.length > 0) {    
            this.test_no = res.data[0].test_no+1       
            // this.status = false;
          } else { 
            this.test_no = 1   
            // AnswerTempTrainingService.getTimeAnswerTemps(this.currentUser.user_id).then(
            //   (res) => {
            //     console.log(res.data.length);
            //     if (res.data == null) {
            //       this.createquestion();
            //     } else {
            //       //  AnswerTempTrainingService.DeleteAnswerTemps(
            //       //     this.currentUser.user_id
            //       //   ).then(() => {
            //       //     this.createquestion();
            //       //   });
            //       // var date = new Date();
            //       // var datestu = new Date(res.data.created_date).getTime();
            //       // datestu = new Date(datestu + 2 * 60 * 60 * 1000);
            //       // // console.log(datestu);
            //       // // console.log(date);
            //       // if (date < datestu) {
            //       //   AnswerTempTrainingService.DeleteAnswerTemps(
            //       //     this.currentUser.user_id
            //       //   ).then(() => {
            //       //     this.createquestion();
            //       //   });
            //       // } else {
            //       //   this.getquestions();
            //       // }
            //     }
            //   }
            // );
          }          
            AnswerTempTrainingService.DeleteAnswerTemps(
              this.currentUser.user_id
            ).then(() => {
              this.createquestion();
            });
        }
      );
    },
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vertical-menu {
  background-color: #eee;
}

.vertical-menu a {
  background-color: #eee;
  color: black;
  display: block;
  padding: 12px;
  text-decoration: none;
}

.vertical-menu a:hover {
  background-color: #ccc;
}

.vertical-menu a.active {
  background-color: #04aa6d;
  color: white;
}
.vertical-left {
  margin-left: 20px;
}
.title {
  color: blue;
}
.hide {
  display: none;
}

.myDIV:hover + .hide {
  display: inline-block;
  color: blue;
}
</style>
